import clsx from 'clsx'
import PropTypes from 'prop-types'

import { ADMIN_ROLES } from '../../shared/const'
import { roleLabel } from '../../shared/helpers'

import styles from './style.module.scss'

/**
 * Die Rolle einer Person als kleines Schild neben ihrem Namen.
 *
 * In den Anforderungen und Anfragen stehen Schüler:innen, Lehrkräfte,
 * Unterstützer:innen und die Verwaltung nebeneinander — in der Liste, im
 * Verlauf, in der Zuweisung. Der Name allein sagt nicht, wer da schreibt, und
 * ob eine Schülerin wartet oder eine Landesadministration nachfragt, ändert die
 * Antwort.
 *
 * **Zwei Farben, kein Regenbogen:** Wer von außen kommt, trägt die kräftige
 * (Mint) — dort wartet jemand. Die eigene Verwaltung bleibt in Grau; sie steht
 * in dieser Ansicht an fast jeder Zeile, und fünf bunte Schilder pro Zeile
 * wären keine Auskunft mehr, sondern Muster.
 *
 * Ohne Rolle (gelöschtes Konto) kommt nichts heraus: Ein leeres Schild wäre
 * eine Behauptung über jemanden, über den wir nichts mehr wissen.
 */
export default function RoleChip({ role, className }) {
	const label = roleLabel(role)
	if (!label) return null

	return (
		<span className={clsx(styles.chip, ADMIN_ROLES.includes(role) ? styles.intern : styles.extern, className)}>
			{label}
		</span>
	)
}

RoleChip.propTypes = {
	// Die Rolle, wie sie am Konto steht (TRoles). Unbekannt oder leer: kein Schild.
	role: PropTypes.string,
	className: PropTypes.string
}

RoleChip.defaultProps = {
	role: null,
	className: ''
}
